import React from 'react';

export default class Settings extends React.Component {
  constructor(props) {
    super(props);

    this.state = { ...props };
  }

  render() {
    const { handleChange } = this.state;
    return (
      <div className="settings">
        <div className="form-group row">
          <div className="col-sm">
            <select name="orderValuePeriod" className="select form-control" onChange={handleChange}>
              <option value="Total">Total</option>
              <option value="New">New</option>
            </select>
          </div>
          <div className="col-sm">
            <select name="orderValueQuality" className="select form-control" onChange={handleChange}>
              <option value="AV">Absolute</option>
              <option value="RV">Per 100.000</option>
            </select>
          </div>
        </div>
      </div>
    );
  }
}
